// extracted by mini-css-extract-plugin
module.exports = {"PromotionworldTeasertemWrapper":"_3vaRv1FLsMCJCNCYBww9aR","ImageWrapper":"n_jpCZ7T9A5qIj2nleILg","PromotionworldTeasertemClickout":"_2OuPmgQBYrNkfy0BgWbvYS"};